/* gallery-quickview.js  shared self-contained quick-view modal.
   Exposes window.GLYQuickView.open(handle) and opens for any element with
   [data-gly-qv][data-handle]. Fetches /products/{handle}.js, lets the shopper pick
   a variant, and adds to cart. Fires 'gly-qv:added' after a successful add so the
   host page can refresh. Money format: window.GLY_MONEY_FORMAT or a [data-money-format]
   element, else '${{amount}}'. Used by the cart and the My Closet page. */
(function () {
  'use strict';

  var qvModal = null, qvProduct = null, qvSelected = [], toastEl = null, qvActiveImg = null;

  function fmt() {
    if (window.GLY_MONEY_FORMAT) return window.GLY_MONEY_FORMAT;
    var el = document.querySelector('[data-money-format]');
    return (el && el.getAttribute('data-money-format')) || '${{amount}}';
  }
  function formatMoney(cents, format) {
    var value = (cents || 0) / 100;
    function withCommas(s) { return s.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'); }
    function replacer(_, token) {
      switch (token) {
        case 'amount': return withCommas(value.toFixed(2));
        case 'amount_no_decimals': return withCommas(value.toFixed(0));
        case 'amount_with_comma_separator': return value.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!,))/g, '$1.');
        case 'amount_no_decimals_with_comma_separator': return withCommas(value.toFixed(0));
        default: return withCommas(value.toFixed(2));
      }
    }
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, replacer);
  }
  function imgUrl(u, w) {
    if (!u) return '';
    var s = String(u);
    if (s.indexOf('//') === 0) s = 'https:' + s;
    return s + (s.indexOf('?') === -1 ? '?' : '&') + 'width=' + (w || 400);
  }
  function escapeHtml(s) { return String(s).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }); }
  function escapeAttr(s) { return escapeHtml(s).replace(/"/g, '&quot;'); }
  function optionName(opt) { return (typeof opt === 'string') ? opt : (opt && opt.name) || ''; }
  function isColorOption(name) { return /colou?r/i.test(name || ''); }
  /* Swatch fill for a colour name — the real swatch hexes live in server metafields
     (not in product.js), so map the common Gallery colours and fall back to the name
     as a CSS colour. */
  var SWATCH = { 'denim': '#4a6b8a', 'soft denim': '#8ba6c1', 'dark denim': '#2e4257', 'black denim': '#2b2f36', 'light denim': '#a7c0d8', 'black': '#1a1a1a', 'white': '#f5f5f0', 'cream': '#efe7d3', 'ivory': '#f2ecdd', 'butter': '#f2e2a8', 'khaki': '#b7a678', 'olive': '#6b6b47', 'brown': '#6b4f3a', 'chocolate': '#4a3529', 'camel': '#c19a6b', 'tan': '#c9a56f', 'natural': '#e6dcc8', 'navy': '#1f2a44', 'bright blue': '#2f6fd0', 'nautical blue': '#2b4f7a', 'iced coffee': '#c8a98a', 'cinnamon': '#9c5a34', 'rust': '#a4512b', 'grey': '#9a9a9a', 'gray': '#9a9a9a', 'charcoal': '#3a3a3a', 'pink': '#e5b8c4', 'blush': '#e7c9c9', 'red': '#b23b3b', 'wine': '#6e2233', 'green': '#4a6b47', 'sage': '#9aa88a' };
  function swatchCss(name) { var k = String(name || '').toLowerCase().trim(); return SWATCH[k] || k.replace(/\s+/g, ''); }

  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'gly-qv-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('show'); });
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('show'); }, 1800);
  }

  function ensureQvModal() {
    if (qvModal) return qvModal;
    qvModal = document.createElement('div');
    qvModal.className = 'gly-qv';
    qvModal.setAttribute('role', 'dialog');
    qvModal.setAttribute('aria-modal', 'true');
    qvModal.innerHTML =
      '<div class="gly-qv__wash" data-gly-qv-close></div>' +
      '<div class="gly-qv__panel">' +
        '<button type="button" class="gly-qv__close" data-gly-qv-close aria-label="Close">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
        '</button>' +
        '<div class="gly-qv__media" data-qv-media></div>' +
        '<div class="gly-qv__body" data-qv-body></div>' +
      '</div>';
    document.body.appendChild(qvModal);

    // swipe the main image to move through the product photos
    var touchX = 0;
    qvModal.addEventListener('touchstart', function (e) { if (e.target.closest('.gly-qv__main')) touchX = e.touches[0].clientX; }, { passive: true });
    qvModal.addEventListener('touchend', function (e) {
      if (!e.target.closest('.gly-qv__main')) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) < 40) return;
      var imgs = (qvProduct && qvProduct.images) || [];
      if (imgs.length < 2) return;
      var i = imgs.indexOf(qvActiveImg); if (i < 0) i = 0;
      i = dx < 0 ? Math.min(i + 1, imgs.length - 1) : Math.max(i - 1, 0);
      qvActiveImg = imgs[i]; renderMedia();
    }, { passive: true });

    return qvModal;
  }

  function openQuickView(handle) {
    if (!handle) return;
    ensureQvModal();
    fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        qvProduct = p;
        var v = null, i;
        for (i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { v = p.variants[i]; break; } }
        if (!v) v = p.variants[0];
        qvSelected = v ? v.options.slice() : [];
        renderQv();
        qvModal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        preloadImages(p.images); // warm the cache so swiping between photos is instant
      })
      .catch(function () {});
  }

  // Preload every product image at display size so flipping/swiping doesn't wait on
  // a fresh network fetch each time.
  function preloadImages(imgs) {
    if (!imgs || !imgs.length) return;
    for (var i = 0; i < imgs.length; i++) { var im = new Image(); im.decoding = 'async'; im.src = imgUrl(imgs[i], 800); }
  }

  function closeQuickView() {
    if (qvModal) { qvModal.classList.remove('is-open'); document.body.style.overflow = ''; }
  }

  function currentQvVariant() {
    if (!qvProduct) return null;
    for (var i = 0; i < qvProduct.variants.length; i++) {
      var vo = qvProduct.variants[i].options, ok = true;
      for (var j = 0; j < vo.length; j++) { if (vo[j] !== qvSelected[j]) { ok = false; break; } }
      if (ok) return qvProduct.variants[i];
    }
    return null;
  }

  function variantForOption(optIndex, value) {
    var best = null;
    for (var i = 0; i < qvProduct.variants.length; i++) {
      var vo = qvProduct.variants[i].options, ok = true;
      for (var j = 0; j < vo.length; j++) {
        var want = (j === optIndex) ? value : qvSelected[j];
        if (vo[j] !== want) { ok = false; break; }
      }
      if (ok) { if (qvProduct.variants[i].available) return qvProduct.variants[i]; if (!best) best = qvProduct.variants[i]; }
    }
    if (best) return best;
    for (var k = 0; k < qvProduct.variants.length; k++) { if (qvProduct.variants[k].options[optIndex] === value) return qvProduct.variants[k]; }
    return null;
  }

  function optionHasAvailable(optIndex, value) {
    for (var i = 0; i < qvProduct.variants.length; i++) {
      var vo = qvProduct.variants[i].options;
      if (vo[optIndex] !== value) continue;
      var ok = true;
      for (var j = 0; j < vo.length; j++) { if (j !== optIndex && vo[j] !== qvSelected[j]) { ok = false; break; } }
      if (ok && qvProduct.variants[i].available) return true;
    }
    return false;
  }

  function renderMedia() {
    if (!qvProduct || !qvModal) return;
    var media = qvModal.querySelector('[data-qv-media]');
    var imgs = (qvProduct.images && qvProduct.images.length) ? qvProduct.images : (qvActiveImg ? [qvActiveImg] : []);
    var active = qvActiveImg || imgs[0] || '';
    var html = '<div class="gly-qv__main">' + (active ? '<img src="' + imgUrl(active, 800) + '" alt="' + escapeAttr(qvProduct.title) + '">' : '') + '</div>';
    if (imgs.length > 1) {
      html += '<div class="gly-qv__thumbs">';
      for (var i = 0; i < imgs.length; i++) {
        var on = imgs[i] === active;
        html += '<button type="button" class="gly-qv__thumb' + (on ? ' on' : '') + '" data-qv-thumb="' + escapeAttr(imgs[i]) + '"><img src="' + imgUrl(imgs[i], 120) + '" alt=""></button>';
      }
      html += '</div>';
    }
    media.innerHTML = html;
  }

  function renderQv() {
    var p = qvProduct; if (!p || !qvModal) return;
    var f = fmt();
    var v = currentQvVariant();
    var body = qvModal.querySelector('[data-qv-body]');
    // active image follows the selected variant; thumb clicks override until the next variant change
    qvActiveImg = (v && v.featured_image && v.featured_image.src) || (p.images && p.images[0]) || p.featured_image;
    renderMedia();

    var price = v ? v.price : p.price;
    var comp = v ? v.compare_at_price : p.compare_at_price;
    var onSale = comp && comp > price;
    var html = '';
    html += '<h3 class="gly-qv__title">' + escapeHtml(p.title) + '</h3>';
    html += '<div class="gly-qv__price"><span>' + formatMoney(price, f) + '</span>' + (onSale ? '<s>' + formatMoney(comp, f) + '</s>' : '') + '</div>';

    var isDefault = p.variants.length === 1 && p.variants[0].title === 'Default Title';
    if (!isDefault) {
      for (var oi = 0; oi < p.options.length; oi++) {
        var oName = optionName(p.options[oi]);
        var color = isColorOption(oName);
        var label = escapeHtml(oName) + (color ? ' · <span class="gly-qv__optval">' + escapeHtml(qvSelected[oi] || '') + '</span>' : '');
        html += '<div class="gly-qv__opt' + (color ? ' gly-qv__opt--color' : '') + '"><div class="gly-qv__opt-label">' + label + '</div><div class="gly-qv__vals' + (color ? ' gly-qv__vals--color' : '') + '" data-qv-opt="' + oi + '">';
        var seen = {}, values = [];
        for (var vi = 0; vi < p.variants.length; vi++) { var val = p.variants[vi].options[oi]; if (!seen[val]) { seen[val] = 1; values.push(val); } }
        for (var k = 0; k < values.length; k++) {
          var value = values[k];
          var sel = qvSelected[oi] === value;
          var avail = optionHasAvailable(oi, value);
          if (color) {
            html += '<button type="button" class="gly-qv__swatch' + (sel ? ' on' : '') + '" data-qv-val="' + escapeAttr(value) + '" aria-pressed="' + (sel ? 'true' : 'false') + '" title="' + escapeAttr(value) + '"' + (avail ? '' : ' disabled') + '><span style="background:' + escapeAttr(swatchCss(value)) + '"></span></button>';
          } else {
            html += '<button type="button" class="gly-qv__val" data-qv-val="' + escapeAttr(value) + '" aria-pressed="' + (sel ? 'true' : 'false') + '"' + (avail ? '' : ' disabled') + '>' + escapeHtml(value) + '</button>';
          }
        }
        html += '</div></div>';
      }
    }

    var addable = v && v.available;
    html += '<div class="gly-qv__foot">';
    // keep the button tappable even when sold out so it can give feedback (a disabled
    // button silently swallows the tap — reads as "nothing happened")
    html += '<button type="button" class="gly-qv__add' + (addable ? '' : ' is-sold') + '" data-qv-add>' + (addable ? 'Add to bag' : (v ? 'Sold out' : 'Unavailable')) + '</button>';
    html += '<a class="gly-qv__full" href="' + p.url + '">View full details</a>';
    html += '</div>';
    body.innerHTML = html;
  }

  function qvAdd(btn) {
    var v = currentQvVariant();
    if (!v || !v.available) { toast(v ? 'That size / colour is sold out' : 'Please choose your options'); return; }
    var original = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: v.id, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) { return r.json().then(function (e) { throw e; }); } return r.json(); })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = (err && (err.description || err.message)) || 'Try again';
        setTimeout(function () { btn.textContent = original; }, 2200);
      });
  }

  document.addEventListener('click', function (e) {
    var qvBtn = e.target.closest('[data-gly-qv]');
    if (qvBtn) { e.preventDefault(); openQuickView(qvBtn.getAttribute('data-handle')); return; }
    if (!qvModal || !qvModal.classList.contains('is-open')) return;
    if (e.target.closest('[data-gly-qv-close]')) { e.preventDefault(); closeQuickView(); return; }
    var thumbBtn = e.target.closest('[data-qv-thumb]');
    if (thumbBtn) { qvActiveImg = thumbBtn.getAttribute('data-qv-thumb'); renderMedia(); return; }
    var valBtn = e.target.closest('[data-qv-val]');
    if (valBtn && !valBtn.disabled) {
      var wrap = valBtn.closest('[data-qv-opt]');
      var oi = parseInt(wrap.getAttribute('data-qv-opt'), 10);
      var target = variantForOption(oi, valBtn.getAttribute('data-qv-val'));
      if (target) qvSelected = target.options.slice();
      else qvSelected[oi] = valBtn.getAttribute('data-qv-val');
      renderQv();
      return;
    }
    var addBtn = e.target.closest('[data-qv-add]');
    if (addBtn) { e.preventDefault(); qvAdd(addBtn); return; }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && qvModal && qvModal.classList.contains('is-open')) closeQuickView(); });

  window.GLYQuickView = { open: openQuickView };
})();
